import React, { Component } from 'react';
import './App.scss'
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import HomePage from './js/pages/HomePage';
import AccessPage from './js/pages/AccessPage';
import MainMenu from './js/components/MainMenu';
import Footer from './js/components/Footer';
import ContactoPage from './js/pages/ContactoPage';
import CatalogosPage from './js/pages/CatalogosPage';
import ProductosPage from './js/pages/ProductosPage';
import ProductoDetallePage from './js/pages/ProductoDetallePage';
import ProductoDetalleExpositorPage from './js/pages/ProductoDetalleExpositorPage';
import ProductoDetalleImplantacionPage from './js/pages/ProductoDetalleImplantacionPage';
import SummaryBudgetPage from './js/pages/SummaryBudgetPage';
import FormBudgetPage from './js/pages/FormBudgetPage';
import { EmpresaPage } from './js/pages/EmpresaPage'
import UserPage from './js/pages/UserPage'
import { connect } from 'react-redux';
import { getColors, getCategories, getZones, getOtherCategories, getState, getProducts } from './js/hooks/gets'
import { setState, setAllProducts, setUserActive, setAllColors, setCategoriesAll, setOtherCategoriesAll, pushFilters, setSelectedCategory, setZones, showSearch } from './js/actions'
import * as _ from 'lodash'
import { infoUser } from './js/hooks/user';
import Popup from './js/components/Popup';
import Spinner from './js/components/Spinner';
import Search from './js/components/Search';
import { PrivacyPolicies } from './js/pages/PrivacyPolicies';
import { CookiePolicy } from './js/pages/CookiePolicy';
import { CookieMessage } from './js/components/CookieMessage';
import Maintenance from './js/components/Maintenance';
import { BRANDCHOSEN } from './js/hooks/config';
import { AvisoLegal } from './js/pages/AvisoLegal';


class App extends Component {
    constructor(props) {
        super(props)

        infoUser().then(res => {
            if (res !== undefined) {
                this.props.setUserActive(res)
            }
        })

        getState().then(res => {
            this.props.setState(res.data)
        })

        this.props.showSearch(false)

        getZones().then(res => {
            const zonesGlobal = _.filter(res.data, ['Global', true]);
            const zonesRegions = _.filter(res.data, ['Global', false]);
            const zonesGlobalOrder = zonesGlobal.sort(Intl.Collator().compare);
            const zonesRegionsOrder = zonesRegions.sort(Intl.Collator().compare);
            const zonesAll = { regions: zonesRegionsOrder, countries: zonesGlobalOrder }
            this.props.setZones(zonesAll)
        })

        getColors().then(res => {
            this.props.setAllColors(res.data)
        })

        getCategories().then(res => {
            console.log("get categories Constructor", res)
            this.props.setCategoriesAll(res)
        })

        getOtherCategories().then(res => {
            console.log("other categories", res);
            this.props.setOtherCategoriesAll(res)
        })

        getProducts().then(res => {
            const products = _.filter(res, product => {
                return product.Estado === 'NUEVO' || product.Estado === 'PROXIMAMENTE';
            })
            if (products.length > 0) {
                const categoryNew = {
                    ID: 9999,
                    Name: 'Nuevo',
                    Position: '99',
                    ImgBanner: '/static/categories/nuevo1900x300-' + BRANDCHOSEN + '.jpg',
                    ImgHome: '/static/categories/nuevo400x300-' + BRANDCHOSEN + '.jpg',
                    Description: '',
                    Collections: []
                }
                getCategories().then(res => {
                    console.log("get categories into get PRoducts ", res)
                    res['fansa'].push(categoryNew)
                    this.props.setCategoriesAll(res)
                })
            }
        })

    }

    componentDidMount() {
        document.addEventListener('contextmenu', (e) => {
            if (e.target.src) {
                e.preventDefault();
            }
        });
    };

    render() {

        return (
            <Router>
                {this.props.state.maintenanceWeb === true ?
                    <Maintenance></Maintenance>
                    :
                    <React.Fragment>
                        <Popup />
                        <MainMenu></MainMenu>
                        <Spinner></Spinner>
                        <Search></Search>
                        <CookieMessage></CookieMessage>

                        <div>
                            <Routes>
                                <Route path="/producto/:id" element={<div className="page-container"><ProductoDetallePage /></div>} />
                                <Route path="/expositor/:id" element={<div className="page-container"><ProductoDetalleExpositorPage /></div>} />
                                <Route path="/outlet" element={<div className="page-container"><ProductosPage /></div>} />
                                <Route path="/expositores" element={<div className="page-container"><ProductosPage /></div>} />
                                <Route path="/implantaciones" element={<div className="page-container"><ProductosPage /></div>} />
                                <Route path="/implantacion/:id" element={<div className="page-container"><ProductoDetalleImplantacionPage /></div>} />
                                <Route path="/categoria" element={<div className="page-container"><ProductosPage /></div>} />
                                <Route path="/categoria/:id" element={<div className="page-container"><ProductosPage /></div>} />
                                <Route path="/promo-a" element={<div className="page-container"><ProductosPage /></div>} />
                                <Route path="/promo-b" element={<div className="page-container"><ProductosPage /></div>} />
                                <Route path="/promo-c" element={<div className="page-container"><ProductosPage /></div>} />
                                <Route path="/empresa" element={<div className="page-container"><EmpresaPage /></div>} />
                                <Route path="/contacto" element={<div className="page-container"><ContactoPage /></div>} />
                                <Route path="/catalogos" element={<div className="page-container"><CatalogosPage /></div>} />
                                <Route path="/acceso" element={<div className="page-container"><AccessPage /></div>} />
                                <Route path="/presupuesto" element={<div className="page-container"><SummaryBudgetPage /></div>} />
                                <Route path="/formulario" element={<div className="page-container"><FormBudgetPage /></div>} />
                                <Route path="/usuario" element={<div className="page-container"><UserPage /></div>} />
                                <Route path="/politica-de-privacidad" element={<div className="page-container"><PrivacyPolicies /></div>} />
                                <Route path="/politica-de-cookies" element={<div className="page-container"><CookiePolicy /></div>} />
                                <Route path="/aviso-legal" element={<div className="page-container"><AvisoLegal /></div>} />
                                <Route path="/" element={<div className="page-container"><HomePage /></div>} />
                                <Route path="/scheurich" element={<div className="page-container"><HomePage /></div>} />
                            </Routes>
                        </div>
                        <Footer />
                    </React.Fragment>
                }

            </Router>
        );
    }
}

const mapDispatchToProps = {
    setState,
    setAllProducts,
    setAllColors,
    setCategoriesAll,
    setOtherCategoriesAll,
    setUserActive,
    pushFilters,
    setSelectedCategory,
    setZones,
    showSearch
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(App)